const asterisk = (promotion, trial, year) => {
  return year > promotion
    ? year > trial
      ? 'two-asterisk'
      : 'one-asterisk'
    : '';
};
export default asterisk;
